import React from 'react';
import { Translate } from '@hydra/common/components';

export default (type: string | number): React.ReactNode => {
  let key = type;
  let extraProps;

  // Status code keys
  if (typeof key === 'number') {
    if (key === 0) {
      key = 'other';
    } else if (key === -1) {
      key = 'misc';
    } else if (key >= 100 && key <= 999) {
      key = `${key}_issue`;
    } else {
      key = key.toString();
    }
  } else {
    // Range keys
    const rangeKey = key.match(/^([^\d]+)_(\d+)_(\d+)$/);
    if (rangeKey && rangeKey.length === 4) {
      const [, base, from, to] = rangeKey;
      const isDuplicate = base.match(/^duplicate/);

      if (isDuplicate) {
        if (from === to) {
          key = 'duplicate_only';
          extraProps = { amount: from };
        } else if (Number(to) > 999) {
          key = 'duplicate_more_than';
          extraProps = { amount: from };
        } else {
          key = 'duplicate_range';
          extraProps = { from, to };
        }
      } else {
        if (from === to && Number(from) === 1) {
          key = 'one_asset';
        } else {
          key = 'asset_range';
          extraProps = { from, to };
        }
      }
    }
  }

  // Keys in the translator use underscores instead of dashes
  key = `crawler_${key.replace(/-/g, '_')}`;

  return <Translate content={key} with={extraProps} />;
};
